export default "__VITE_ASSET__yIZWz50L__"